<template>
  <button
    v-if="isMobile"
    class="mobile-sidebar-toggle"
    @click="toggleSidebar"
    :aria-label="ariaLabel"
  >
    <i class="pi pi-bars"></i>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  isMobile: boolean;
  toggleSidebar: () => void;
  ariaLabel: string;
}>();
</script>

<style scoped>
.mobile-sidebar-toggle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
  border: none;
  box-shadow: 0 4px 12px hsl(var(--foreground) / 0.2);
  cursor: pointer;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.mobile-sidebar-toggle:hover {
  box-shadow: 0 6px 16px hsl(var(--foreground) / 0.25);
}

.mobile-sidebar-toggle:active {
  transform: scale(0.95);
}

.mobile-sidebar-toggle i {
  font-size: 1rem;
}
</style>

